import {Store} from 'client/common/types';
import {connect} from 'react-redux';

import {getSurvey} from 'client/common/store/selectors/survey';
import {getTestBuckets} from 'client/common/store/selectors/user';

import {StateProps} from './types';

import Component from './preview';

function mapStateToProps(state: Store): StateProps {
    const {slug} = getSurvey(state);
    const testBuckets = getTestBuckets(state);

    return {
        slug,
        testBuckets
    };
}

export default connect<StateProps>(mapStateToProps)(Component);
